import { Capacitor } from "@capacitor/core";
import { api } from "@/lib/apiClient";

// True when running inside the Astra iPhone app (Capacitor shell), false on the website.
export const isNative = Capacitor.isNativePlatform();
// Signed-out home for public pages: the iPhone app opens on a welcome screen, so horoscopes live at /horoscopes.
export const PUBLIC_HOME = isNative ? "/horoscopes" : "/";

export async function nativeAppleSignIn() {
  const { SignInWithApple } = await import("@capacitor-community/apple-sign-in");
  const nonce = crypto.randomUUID().replace(/-/g, "");
  const { response } = await SignInWithApple.authorize({
    clientId: "com.astralogico.astra",
    redirectURI: "https://astralogico.com/api/auth/apple/callback",
    scopes: "email name",
    nonce,
  });
  const name = [response.givenName, response.familyName].filter(Boolean).join(" ");
  const ref = localStorage.getItem("astra_ref") || undefined;
  const { data } = await api.post("/auth/apple/native", { id_token: response.identityToken, nonce, name, ref });
  localStorage.removeItem("astra_ref");
  return data;
}

// Resolves "registered", "denied", "error" or "timeout" so callers can explain what happened.
export async function registerPush() {
  if (!isNative) return "web";
  const { PushNotifications } = await import("@capacitor/push-notifications");
  const perm = await PushNotifications.requestPermissions();
  if (perm.receive !== "granted") return "denied";
  const handles = [];
  const done = new Promise((resolve) => {
    handles.push(PushNotifications.addListener("registration", ({ value }) => {
      api.post("/push/register", { token: value, platform: "ios" }).then(() => resolve("registered")).catch(() => resolve("error"));
    }));
    handles.push(PushNotifications.addListener("registrationError", () => resolve("error")));
    setTimeout(() => resolve("timeout"), 8000);
  });
  await PushNotifications.register();
  const result = await done;
  (await Promise.all(handles)).forEach((h) => h.remove());
  return result;
}

// Tapping a notification opens the page it points to (the daily reading by default).
export async function listenForPushTaps(navigate) {
  if (!isNative) return () => {};
  try {
    const { PushNotifications } = await import("@capacitor/push-notifications");
    const h = await PushNotifications.addListener("pushNotificationActionPerformed", ({ notification }) => {
      const path = notification?.data?.path;
      navigate(typeof path === "string" && path.startsWith("/") ? path : "/today?glow=1");
    });
    return () => h.remove();
  } catch {
    return () => {};
  }
}
